import { CalendarDate, ZonedDateTime } from '@internationalized/date';
import {
  LoadStatus,
  Money,
  SalesItemLineType,
  SalesLoadLineItemPhase,
  Unit,
  Weight,
  WeightDisplayUnit,
} from '@rematter/frontend-lib-api-client';

export type BrokeredLoadDetailsTab =
  | 'load-info'
  | 'materials'
  | 'photos'
  | 'documents'
  | 'notes';

export enum enumBrokeredLoadWeightType {
  Gross = 'gross',
  Tare = 'tare',
  Net = 'net',
  QuantityOwed = 'quantityOwed',
}

export interface BrokeredLoadLineItemRecord {
  id: string;
  loadId?: string | null;
  type: SalesItemLineType;
  itemId: string | null;
  item?: {
    id: string;
    name: string;
    skuNumber?: string | null;
  } | null;
  purchaseOrderId?: string | null;
  purchaseOrder?: {
    id: string;
    documentNumber: string;
  } | null;
  phase?: SalesLoadLineItemPhase | null;
  unitPrice?: Money | null;
  estimatedPrice?: Money | null;
  pricingUnit?: Unit | null;
  weights?: Record<string, Weight> | null;
}

export interface BrokeredLoadRecord {
  id: string;
  loadNumber: string;
  status: LoadStatus;
  reviewed: boolean;
  expectedShipDate?: CalendarDate;
  shippedDate?: CalendarDate | null;
  loadReceivedDate?: CalendarDate | null;
  salesOrderId?: string | null;
  salesOrderNumber?: string | null;
  bookingId?: string | null;
  bookingNumber?: string | null;
  facilityId?: string | null;
  supplierId: string;
  supplier: {
    id: string;
    name: string;
  };
  brokeredOrderId?: string | null;
  brokeredOrder?: {
    id: string;
    orderNumber: string;
  } | null;
  customerName?: string | null;
  recyclerInternalNotes?: string | null;
  recyclerExternalNotes?: string | null;
  customerInternalNotes?: string | null;
  customerExternalNotes?: string | null;
  deliveryNumber?: string | null;
  releaseNumber?: string | null;
  truckNumber?: string | null;
  trailerNumber?: string | null;
  containerNumber?: string | null;
  sealNumber?: string | null;
  heavyWeight?: Weight | null;
  lightWeight?: Weight | null;
  files?: Array<{
    id: string;
    fileName: string;
    fileSize: number;
    mimeType: string;
    status: string;
    downloadUrl?: string;
    entityType?: string;
    entityId?: string;
    metadata?: Record<string, unknown>;
    createdAt: ZonedDateTime;
    updatedAt: ZonedDateTime;
  }>;
  timestamps: {
    createdAt: ZonedDateTime;
    updatedAt?: ZonedDateTime;
  };
  weightDisplayUnit?: WeightDisplayUnit;
  lineItemCount?: number;
  netQuantity?: number;
  netRequestedQuantity?: number;
  shippedNetWeight?: number;
  shippedTotal?: number;
  lineItems: BrokeredLoadLineItemRecord[];
}

export type BrokeredLoadFormLineItem = {
  id: string;
  type?: SalesItemLineType | null;
  itemId?: string | null;
  purchaseOrderId?: string | null;
  phase?: SalesLoadLineItemPhase | null;
  unitPrice?: Money | null;
  estimatedPrice?: Money | null;
  pricingUnit?: Unit | null;
  weights?: Partial<Record<enumBrokeredLoadWeightType, Weight>> | null;
};

export type BrokeredLoadFormState = {
  documentNumber?: string;
  supplierId?: string;
  brokeredOrderId?: string;
  salesOrderId?: string;
  bookingId?: string;
  facilityId?: string;
  expectedShipDate?: CalendarDate;
  status?: LoadStatus;
  weightDisplayUnit?: WeightDisplayUnit;
  deliveryNumber?: string;
  releaseNumber?: string;
  truckNumber?: string;
  trailerNumber?: string;
  containerNumber?: string;
  sealNumber?: string;
  recyclerInternalNotes?: string;
  recyclerExternalNotes?: string;
  lineItems: BrokeredLoadFormLineItem[];
};
